import React from 'react';
import './HomeSkeleton.css';

const slots = [0, 1, 2, 3];

function Heading({side = false}) {
    const copy = <>
        <span className="ps-home-skeleton__subtitle" />
        <span className="ps-home-skeleton__title" />
    </>;
    return <div className={`ps-home-skeleton__heading${side ? ' ps-home-skeleton__heading--side' : ''}`} aria-hidden="true">
        {side ? <><span className="ps-home-skeleton__heading-icon"/><div>{copy}</div><span className="ps-home-skeleton__heading-rule"/></> : <>{copy}<span className="ps-home-skeleton__divider" /></>}
    </div>;
}

export default function HomeSkeleton() {
    return (
        <div className="ps-home-skeleton" role="status" aria-label="Loading homepage" aria-busy="true">
            <div className="ps-header__video-banner ps-home-skeleton__hero" aria-hidden="true" data-placeholder="hero-video">
                <div className="ps-header__video-frame"><span className="ps-home-skeleton__hero-image"/></div>
            </div>
            <div className="container" aria-hidden="true">
                <section className="ps-home-skeleton__section" data-placeholder="category-grid">
                    <Heading />
                    <div className="ps-home-skeleton__grid">
                        {slots.map((slot) => <div className="ps-home-skeleton__category" key={slot}>
                            <span className="ps-home-skeleton__category-image" />
                            <div className="ps-home-skeleton__category-copy">
                                <span className="ps-home-skeleton__name" />
                                <span className="ps-home-skeleton__button" />
                            </div>
                        </div>)}
                    </div>
                </section>
                <section className="ps-home-skeleton__section" data-placeholder="product-carousel">
                    <Heading />
                    <div className="ps-home-skeleton__grid">
                        {slots.map((slot) => <div className="ps-home-skeleton__product" key={slot}>
                            <span className="ps-home-skeleton__product-image" />
                            <div className="ps-home-skeleton__product-copy">
                                <span className="ps-home-skeleton__name" />
                                <span className="ps-home-skeleton__name ps-home-skeleton__name--short" />
                                <span className="ps-home-skeleton__rating" />
                                <span className="ps-home-skeleton__price" />
                                <span className="ps-home-skeleton__button" />
                            </div>
                        </div>)}
                    </div>
                </section>
                <section className="ps-home-skeleton__section" data-placeholder="featured-product">
                    <Heading />
                    <div className="ps-home-skeleton__featured-grid">{[0,1].map(slot => <div className="ps-home-skeleton__featured" key={slot}>
                        <span className="ps-home-skeleton__featured-image"/>
                        <div className="ps-home-skeleton__featured-copy"><span className="ps-home-skeleton__rating"/><span className="ps-home-skeleton__name"/><span className="ps-home-skeleton__name ps-home-skeleton__name--short"/><span className="ps-home-skeleton__price"/><span className="ps-home-skeleton__button"/></div>
                    </div>)}</div>
                    <div className="ps-home-skeleton__pagination"><span/><span/><span/></div>
                </section>
                <section className="ps-home-skeleton__section" data-placeholder="banner-grid">
                    <Heading side />
                    <div className="ps-home-skeleton__banner-grid">{slots.map(slot => <div className="ps-home-skeleton__banner-card" key={slot}>
                        <span className="ps-home-skeleton__banner-image"/>
                        <div className="ps-home-skeleton__banner-caption"><span className="ps-home-skeleton__name"/><span className="ps-home-skeleton__caption-line"/></div>
                    </div>)}</div>
                </section>
                <section className="ps-home-skeleton__section" data-placeholder="banner">
                    <Heading />
                    <div className="ps-home-skeleton__banner"><span /></div>
                </section>
                <section className="ps-home-skeleton__section" data-placeholder="promotion">
                    <Heading />
                    <div className="ps-home-skeleton__promotion-grid">{[0,1].map(slot => <div className="ps-home-skeleton__promotion" key={slot}>
                        <span className="ps-home-skeleton__promotion-image"/>
                        <div className="ps-home-skeleton__promotion-copy"><span className="ps-home-skeleton__name"/><span className="ps-home-skeleton__caption-line"/><span className="ps-home-skeleton__caption-line"/><span className="ps-home-skeleton__button"/></div>
                    </div>)}</div>
                </section>
            </div>
        </div>
    );
}
